import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpowelmidcmumbai() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Powai MIDC Mumbai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Powai MIDC Mumbai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Corporate Cab Services in Powai MIDC Mumbai, serving the transportation needs of corporate offices, business parks, and commercial hubs in the area. Our fleet of well-maintained sedans, SUVs, and executive vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, business meetings, inter-office travel, or VIP movement, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Powai MIDC Mumbai.',

    top: 'Top Places to Visit in Powai with Pune Corporate Car',

 "topPlaces": [
  {
    "title": "Powai Lake",
    "description": "Powai Lake is the heart of the neighborhood and one of Mumbai’s most picturesque water bodies. Built during British rule, it offers beautiful promenades, cycling paths, waterfront seating areas, and a calm natural escape from the city’s bustle. At sunrise and sunset, the lake glows with reflections of surrounding hills and skyscrapers, while bird watchers often spot migratory species, purple herons, and kingfishers. It is a favorite spot for couples, joggers, photographers, and nature lovers alike."
  },
  {
    "title": "Hiranandani Gardens",
    "description": "Hiranandani Gardens is Powai’s iconic township known for its grand European-style architecture, wide boulevards, landscaped gardens, luxury residences, and bustling high street markets. The beautifully designed buildings feature Greco-Roman influences, arches, domes, and majestic facades that give the area a distinct identity within Mumbai. With its coffee shops, fine dining restaurants, retail stores, and lively nightlife, Hiranandani Gardens is the urban soul of Powai."
  },
  {
    "title": "Powai Garden",
    "description": "Powai Garden is a lush lakeside park ideal for morning walks, family outings, and peaceful relaxation beneath ancient trees and flowering plants. The garden includes jogging tracks, children’s play areas, a small bridge, and shaded seating arrangements offering scenic views of Powai Lake. The natural green setting makes it a soothing public space for exercise, reading, bird watching, or spending quiet time in nature."
  },
  {
    "title": "IIT Bombay",
    "description": "IIT Bombay is one of India’s most prestigious educational institutions, known for its sprawling green campus, academic excellence, and innovation-driven culture. The tranquil grounds include lakeside trails, nature parks, tree-covered paths, and iconic structures like the convocation hall and academic buildings. The campus hosts major cultural fests like Mood Indigo and Techfest, drawing national and international students, artists, leaders, and performers every year."
  },
  {
    "title": "Galleria Mall",
    "description": "Hiranandani’s Galleria Mall is a popular shopping and hangout destination offering a mix of branded stores, street-style stalls, cafés, electronics shops, eateries, bookshops, and services. Built with European-style stone architecture, the marketplace is always buzzing with families, college students, and office-goers. Whether one is shopping, grabbing a quick snack, or simply strolling around, the lively marketplace atmosphere captures the urban lifestyle of Powai."
  },
  {
    "title": "Forest Hiking Trails Around IIT and Powai Hills",
    "description": "Powai is surrounded by green hill ranges offering natural trails for jogging, hiking, and trekking. Many of these paths run through the wooded borders of IIT, the Powai Hills, and adjoining forest belts connected to the Sanjay Gandhi National Park ecosystem. During monsoon, these routes come alive with dense greenery, small waterfalls, chirping birds, and misty views, making it a perfect outdoor escape for fitness enthusiasts and nature explorers."
  },
  {
    "title": "Jagadeeshwara Temple",
    "description": "Located near Hiranandani Gardens, the Jagadeeshwara Temple is a serene Shiva temple surrounded by landscaped courtyards and lush greenery. Devotees visit daily for prayers, while festivals like Mahashivratri bring illuminated decorations, devotional chants, and a festive community spirit. The temple’s peaceful environment offers a calming break amid Powai’s urban environment, making it a popular spiritual landmark."
  },
  {
    "title": "Hakone Entertainment Centre",
    "description": "Hakone is Powai’s favorite entertainment and fun zone, featuring go-kart racing, arcade games, bowling, rides, virtual reality experiences, and family-friendly attractions. From kids to adults, visitors find a wide range of activities for weekend fun, birthday parties, and group outings. Located near the waterfront and surrounded by greenery, Hakone blends outdoor enjoyment with indoor gaming excitement."
  },
  {
    "title": "Little World of Street Food & Cafés",
    "description": "Powai is a food lover’s paradise offering a mix of high-end dining restaurants, trendy Insta-worthy cafés, cozy dessert places, food trucks, and street stalls. From continental breakfasts and artisanal coffee to biryani, chaat, momos, shawarma, and late-night snacks, Powai’s culinary map caters to every craving. Young professionals, students, and food explorers frequent the area daily, making Powai a vibrant dining and nightlife hotspot."
  },
  {
    "title": "Lake Homes and Riverside Promenades",
    "description": "The residential townships around Powai Lake include scenic promenades, landscaped walkways, jogging tracks, and peaceful waterfront seating areas. Residents and visitors enjoy cycling, yoga sessions, evening strolls, and quiet moments overlooking the water and the city skyline. The combination of scenic views, greenery, and luxury living makes this part of Powai one of the most desirable residential settings in Mumbai."
  }
],


"services": [
{
"name": "Marol MIDC Employee Cab",
"description": "Marol MIDC Employee Cab provides reliable and structured transportation for employees working in Marol MIDC. The service offers trained drivers, GPS-enabled vehicles, multi-shift scheduling, and optimized routes to ensure safe, comfortable, and punctual commuting for corporate and industrial staff."
},
{
"name": "Corporate Shuttle Andheri",
"description": "Corporate Shuttle Andheri delivers organized multi-passenger shuttle services for corporate offices, IT parks, and industrial units in Andheri. With GPS-monitored vehicles, professional drivers, structured routes, and multi-shift support, the service ensures efficient, safe, and timely employee transport."
},
{
"name": "Office Pickup Drop Marol",
"description": "Office Pickup Drop Marol offers dependable daily pickup and drop services for office employees and corporate staff. The service features punctual pickups, well-maintained vehicles, trained chauffeurs, and GPS-enabled tracking to ensure smooth and stress-free commuting."
},
{
"name": "Worker Cab Marol Andheri",
"description": "Worker Cab Marol Andheri provides structured transport solutions for factory and industrial workers in Marol and Andheri. The service includes multi-shift support, trained drivers, GPS-enabled vehicles, and safe, timely, and comfortable daily commuting."
},
{
"name": "Industrial Transport Marol MIDC",
"description": "Industrial Transport Marol MIDC specializes in transporting large numbers of employees across industrial units. The service ensures punctual, safe, and organized commuting with well-maintained vehicles, trained chauffeurs, GPS tracking, and structured multi-shift routes."
},
{
"name": "Monthly Cab Hire Marol",
"description": "Monthly Cab Hire Marol provides long-term cab rental solutions for companies requiring consistent employee commuting. The service includes fixed monthly plans, trained drivers, GPS-enabled vehicles, and structured routes to ensure reliable and efficient daily transport."
},
{
"name": "Business Travel Cab Andheri",
"description": "Business Travel Cab Andheri offers professional corporate transportation for executives, client visits, and business trips. The service features trained chauffeurs, GPS-enabled vehicles, well-maintained cars, and optimized routes for comfortable and punctual business travel."
},
{
"name": "Affordable Staff Cab Marol MIDC",
"description": "Affordable Staff Cab Marol MIDC provides cost-effective transportation solutions for employees in industrial and corporate offices. The service ensures reliable pickups, well-maintained vehicles, trained drivers, GPS tracking, and structured schedules for safe and budget-friendly commuting."
},
{
"name": "Outstation Cab Marol",
"description": "Outstation Cab Marol delivers long-distance travel solutions for corporate employees and business executives. The service features GPS-enabled vehicles, trained drivers, optimized routes, and comfortable seating to ensure safe, punctual, and hassle-free intercity commuting."
},
{
"name": "Sedan Cab Marol Andheri",
"description": "Sedan Cab Marol Andheri provides premium sedans for corporate staff, executives, and office visitors. The service ensures well-maintained vehicles, trained chauffeurs, GPS tracking, and punctual pickups for safe, comfortable, and professional commuting."
},
{
"name": "SUV Cab Andheri MIDC",
"description": "SUV Cab Andheri MIDC offers spacious and comfortable SUVs suitable for team travel, industrial staff transport, and executive commuting. The service includes trained chauffeurs, GPS-enabled vehicles, structured routes, and multi-shift support to ensure safe and reliable transportation."
},
{
"name": "Best Corporate Cab Marol",
"description": "Best Corporate Cab Marol provides top-quality corporate transportation for office staff, executives, and industrial employees. The service features punctual pickups, trained drivers, GPS-enabled vehicles, structured routes, and well-maintained sedans and SUVs for seamless commuting."
},
{
"name": "Employee Commute Andheri East",
"description": "Employee Commute Andheri East offers structured and dependable transport solutions for office and industrial employees. The service ensures GPS-monitored vehicles, trained drivers, multi-shift scheduling, and optimized routes for safe, comfortable, and timely commuting."
},
{
"name": "Corporate Fleet Marol MIDC",
"description": "Corporate Fleet Marol MIDC provides fully managed corporate fleet solutions, including sedans, SUVs, and staff cabs. The service covers vehicle maintenance, driver management, GPS tracking, and structured routes to ensure seamless, safe, and efficient employee transportation."
},
{
"name": "Staff Shuttle Andheri East",
"description": "Staff Shuttle Andheri East delivers organized multi-passenger shuttle services for corporate offices, IT parks, and industrial units. The service features trained drivers, GPS-enabled vehicles, structured routes, and multi-shift support for safe, punctual, and efficient staff commuting."
}
],

"tableData": [
["Marol MIDC Employee Cab", "Corporate Shuttle Andheri"],
["Office Pickup Drop Marol", "Worker Cab Marol Andheri"],
["Industrial Transport Marol MIDC", "Monthly Cab Hire Marol"],
["Business Travel Cab Andheri", "Affordable Staff Cab Marol MIDC"],
["Outstation Cab Marol", "Sedan Cab Marol Andheri"],
["SUV Cab Andheri MIDC", "Best Corporate Cab Marol"],
["Employee Commute Andheri East", "Corporate Fleet Marol MIDC"],
["Staff Shuttle Andheri East", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Powai MIDC Mumbai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers dependable corporate cab services in Powai MIDC Mumbai, ensuring seamless and efficient transportation for business employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drop-offs, helping employees reach offices, industrial zones, and business hubs in Powai MIDC Mumbai without delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Powai MIDC Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]
































  }

const faqData = [
  {
    question: 'Do you provide cab services in Marol MIDC, Andheri?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional cab services for employees and corporate clients in Marol MIDC, Andheri.',
  },
  {
    question: 'What types of cab services are available in Marol MIDC, Andheri?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions.',
  },
  {
    question: 'Do you support daily commuting for employees in Marol MIDC?',
    answer: 'Yes, we offer optimized daily commute solutions with timely pickups and flexible shift schedules for corporate offices in Andheri.',
  },
  {
    question: 'How can companies book cab services in Marol MIDC, Andheri?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on employee strength and corporate needs.',
  },
  {
    question: 'Can companies avail long-term cab contracts in Marol MIDC, Andheri?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and transparent terms.',
  },
  {
    question: 'Are safety and tracking features included in cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Marol MIDC?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Marol MIDC, Andheri?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Kulkarni',
    feedback: 'Professional cab service for employees in Marol MIDC, Andheri. Punctual, safe, and hassle-free transportation.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shreya Mehta',
    feedback: 'Excellent corporate cab service in Andheri. Smooth commuting experience for our team every day.',
    rating: 5,
  },
];





























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Powai MIDC Mumbai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-powai-midc.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services in Powai MIDC Mumbai, offering staff transportation, corporate shuttles, office pickup & drop, employee mobility solutions, monthly cab hire plans, business travel cabs, outstation services, and chauffeur-driven executive cars for companies operating in Powai MIDC.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-powai-midc-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Powai MIDC Mumbai | Staff & Business Travel</title>

  <meta
    name="description"
    content="Premium corporate cab services in Powai MIDC Mumbai including staff transport, corporate shuttles, office pickup & drop, employee mobility, monthly cab hire, business taxis, outstation cabs, and chauffeur-driven executive cars. Reliable transport solutions for Powai companies."
  />

  <meta
    name="keywords"
    content="Powai Corporate Shuttle, Powai MIDC Staff Transport, Company Cab Powai, Office Pickup Drop Powai, Corporate Fleet Powai MIDC, Affordable Cab Powai, Monthly Cab Hire Powai, Business Taxi Powai, Best Corporate Cabs Powai Mumbai, Employee Mobility Powai, Outstation Cab Powai MIDC, Sedan Cab Powai, SUV Cab Powai, Corporate Travel Powai, Staff Shuttle Powai MIDC"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpowelmidcmumbai;